import type { ComponentProps } from "react";

import { cn } from "@/shared/lib/cn";

export function ButtonGroup({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      role="group"
      data-slot="button-group"
      className={cn(
        "inline-flex items-stretch [&>[data-slot=button]]:rounded-none [&>[data-slot=button]:first-child]:rounded-l-[var(--radius-sm)] [&>[data-slot=button]:last-child]:rounded-r-[var(--radius-sm)] [&>[data-slot=button]+[data-slot=button]]:-ml-px",
        className,
      )}
      {...props}
    />
  );
}
